import React from 'react'
import classnames from 'classnames'
import ReactSVG from 'react-svg'

import { StateConsumer } from '../../../state'
import styles from './settings-button.css'
import settingsIcon from '../../../../../../images/player-settings-icon.svg'
import { isTitle } from '../../../../../lib/content'

const SettingsButton = () => (
  <StateConsumer>
    {({
      toggleSettingsPanelOpen,
      isSettingsPanelOpen,
      contentItem,
      isSafari
    }) => {
      const isTitleContent = isTitle(contentItem)
      const shouldHideSettingsButton = isSafari && isTitleContent

      // Safari does not support changing video quality and autoplay is not applicable for title content,
      // so we hide the settings button in this case to avoid confusion
      if (shouldHideSettingsButton) {
        return null
      }

      return (
        <div className={styles.wrapper} onClick={toggleSettingsPanelOpen}>
          <div className={styles.iconWrapper}>
            <button
              type="button"
              className={styles.iconButton}
            >
              <ReactSVG
                src={settingsIcon}
                className={classnames(styles.icon, {
                  [styles.activeIcon]: isSettingsPanelOpen
                })}
              />
            </button>
          </div>
        </div>
      )
    }}
  </StateConsumer>
)

export default SettingsButton
